var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from "react";
import styled from "react-emotion";
import { channel, contextTypes } from "emotion-theming";
import { breakpointRaw, breakpoint, maxBreakpoint } from "../utils";
import Box from "./Box";
var mediaQuery = function mediaQuery(p) {
  if (p.media) return p.media;
  if (p.minHeight || p.maxHeight) {
    var _min = p.minHeight ? "(min-height: " + breakpoint(p.minHeight)(p) + ")" : "";
    var _max = p.maxHeight ? "(max-height: " + maxBreakpoint(p.maxHeight)(p) + ")" : "";
    var _minIsLowerThanMax = _min && _max && breakpointRaw(p.minHeight)(p) < breakpointRaw(p.maxHeight)(p);
    var _separator = _min && _max && _minIsLowerThanMax ? "and" : ",";
    return _min + " " + _separator + " " + _max;
  }
  var min = p.min ? "(min-width: " + breakpoint(p.min)(p) + ")" : "";
  var max = p.max ? "(max-width: " + maxBreakpoint(p.max)(p) + ")" : "";
  var minIsLowerThanMax = min && max && breakpointRaw(p.min)(p) < breakpointRaw(p.max)(p);
  var separator = min && max && minIsLowerThanMax ? "and" : ",";
  return min + " " + separator + " " + max;
};
var DynamicOn = function (_PureComponent) {
  _inherits(DynamicOn, _PureComponent);
  function DynamicOn() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, DynamicOn);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DynamicOn.__proto__ || Object.getPrototypeOf(DynamicOn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      matches: false,
      theme: {}
    }, _this.updateMatches = function () {
      return _this.setState({
        matches: _this.mq.matches
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(DynamicOn, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object") return;
      var themeContext = this.context[channel];
      if (themeContext !== undefined) {
        this.unsubscribeId = themeContext.subscribe(function (theme) {
          return _this2.setState({
            theme: theme
          }, _this2.updateListener);
        });
      } else {
        this.updateListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mq.removeListener(this.updateMatches);
      if (this.unsubscribeId !== undefined && this.unsubscribeId !== -1) {
        this.context[channel].unsubscribe(this.unsubscribeId);
      }
    }
  }, {
    key: "updateListener",
    value: function updateListener() {
      if (this.mq) this.mq.removeListener(this.updateMatches);
      var query = mediaQuery(_extends({}, this.props, {
        theme: this.state.theme
      }));
      this.mq = matchMedia(query);
      this.mq.addListener(this.updateMatches);
      this.updateMatches();
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof this.props.children === "function") {
        return this.props.children(this.state.matches, !this.state.matches);
      }
      return this.state.matches ? this.props.children : null;
    }
  }]);
  return DynamicOn;
}(PureComponent);
DynamicOn.contextTypes = contextTypes;
var StaticOn = /*#__PURE__*/styled(function (_ref2) {
  var min = _ref2.min,
    max = _ref2.max,
    media = _ref2.media,
    props = _objectWithoutProperties(_ref2, ["min", "max", "media"]);
  return React.createElement(Box, props);
}, {
  label: "StaticOn",
  target: "css-18q6ews0"
})("display:none;", function (p) {
  return "@media " + (p.media ? p.media : mediaQuery(p));
}, "{", function (p) {
  return p.inline ? "display:inline-block" : "display:block";
}, ";}");
var On = function On(_ref3) {
  var dynamic = _ref3.dynamic,
    props = _objectWithoutProperties(_ref3, ["dynamic"]);
  return dynamic ? React.createElement(DynamicOn, props) : React.createElement(StaticOn, props);
};
export default On;